import { useParams } from "react-router";
import { ApiError } from "@/api";
import { MicroAppViewerPage } from "@/features/build/microApps/MicroAppViewerPage";
import { NotFoundPage } from "@/features/errors/NotFoundPage";
import { spaceCrumb } from "../spaceCrumb";
import { useSpaceHub } from "./useSpaceHub";

/**
 * `/spaces/:spaceUuid/apps/:uuid`: a micro-app opened from a space (pinned or in its
 * Apps), kept under the space (`{Space} / {App}`) and available on every surface,
 * unlike Build. The app's own access is checked by the backend as usual.
 */
export function SpaceAppPage() {
  const { spaceUuid = "" } = useParams();
  const hub = useSpaceHub(spaceUuid);
  if (hub.error instanceof ApiError && (hub.error.status === 404 || hub.error.status === 403)) {
    return <NotFoundPage />;
  }
  return <MicroAppViewerPage space={spaceCrumb(spaceUuid, hub.data?.name)} />;
}
